// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Marquee_wrap_1jQmx","content":"Marquee_content_1sWpy","text":"Marquee_text_195xm","animation":"Marquee_animation_3gaNS","paused":"Marquee_paused_2Q2RR"};